(function($, Drupal, once) {
  Drupal.behaviors.jnjmdcMultiAssetsDiscoverZebra = {
    attach(context) {
      $(
        once(
          'discover-zebra',
          '.paragraph--type--jnjmdc-multi-asset-paragraph',
          context
        )
      ).each(function() {
        const discoverZebra = new Drupal.jnjos.DiscoverZebra($(this));
        const zebraColorClass =
          discoverZebra.getZebraBackgroundColor() === 'rgb(244,244,244)'
            ? 'accent-color'
            : 'neutral-color';
        $(this).addClass(zebraColorClass);
      });
    },
  };
})(jQuery, Drupal, once);
